import React from "react";
import { useWizard, PHOTO_CATEGORIES } from "../../lib/wizardStore";
import { Camera, Check, Clock3 } from "lucide-react";

export default function PhotosStep() {
  const { state, updatePhotos } = useWizard();

  return (
    <div className="space-y-5">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900">
          Plan your photos
        </h2>
        <p className="text-slate-500 mt-2">
          Photos boost clicks by up to 35%. You’ll upload these directly to Google Business Profile after approval — we’ll show you exactly how. For now, mark which ones you have ready.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        {PHOTO_CATEGORIES.map((cat) => {
          const status = state.photos[cat.id];
          const ready = status === "ready";
          return (
            <div
              key={cat.id}
              data-testid={`photo-card-${cat.id}`}
              className={`rounded-2xl border p-4 transition-all ${
                ready ? "border-emerald-500 bg-emerald-50/40" : "border-slate-200 bg-white"
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
                  ready ? "bg-emerald-500 text-white" : "bg-slate-100 text-slate-600"
                }`}>
                  <Camera className="w-5 h-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-slate-900">{cat.label}</div>
                  <div className="text-xs text-slate-500 mt-0.5 leading-relaxed">{cat.desc}</div>
                </div>
              </div>

              <div className="mt-4 flex gap-2">
                <button
                  data-testid={`photo-${cat.id}-pending`}
                  onClick={() => updatePhotos(cat.id, "pending")}
                  className={`flex-1 inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-full px-3 py-1.5 transition-colors ${
                    !ready ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                  }`}
                >
                  <Clock3 className="w-3.5 h-3.5" /> Pending
                </button>
                <button
                  data-testid={`photo-${cat.id}-ready`}
                  onClick={() => updatePhotos(cat.id, "ready")}
                  className={`flex-1 inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-full px-3 py-1.5 transition-colors ${
                    ready ? "bg-emerald-500 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                  }`}
                >
                  <Check className="w-3.5 h-3.5" /> Ready
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
